import React from 'react';
import { useParams } from 'react-router-dom';
import { Card, Alert } from 'react-bootstrap';

import useFetchById from 'hooks/useFetchById';

import WarehouseSection from 'components/admin/warehouse/WarehouseDetail/WarehouseSection';
import POAddressSection from 'components/admin/warehouse/WarehouseDetail/POAddressSection';
import WarehouseAddressEditor from 'components/admin/warehouse/WarehouseDetail/WarehouseAddressEditor';
import ChannelSettingsSection from 'components/admin/warehouse/WarehouseDetail/ChannelSettingsSection';

import { adminWarehouseApi } from 'api';

const WarehouseDetail = () => {
  const { warehouseId } = useParams();

  const {
    data: warehouse,
    loading: fetchLoading,
    error: fetchError,
    refetch,
  } = useFetchById(adminWarehouseApi, warehouseId);
  if (fetchLoading) {
    return (
      <Card className="h-100">
        <Card.Body>
          <div className="text-center">Loading...</div>
        </Card.Body>
      </Card>
    );
  }

  if (fetchError) {
    return (
      <Card className="h-100">
        <Card.Body>
          <Alert variant="danger">{fetchError}</Alert>
        </Card.Body>
      </Card>
    );
  }

  return (
    <>
      <WarehouseSection
        warehouseId={warehouseId}
        warehouse={warehouse}
        refetch={refetch}
      />

      {warehouse && (
        <ChannelSettingsSection
          warehouseId={warehouseId}
          channelSettings={warehouse?.channel_settings}
          warehouseDomain={warehouse?.domain || warehouse?.warehouse?.domain}
          refetch={refetch}
        />
      )}

      {warehouse?.purchase_order_invoice_address ? (
        <POAddressSection
          warehouseId={warehouseId}
          purchaseOrderAddress={warehouse?.purchase_order_invoice_address}
          refetch={refetch}
        />
      ) : null}

      {warehouse ? (
        <WarehouseAddressEditor
          warehouseId={warehouse?.id}
          initialBilling={warehouse?.gate_pass_document_billing_address}
          initialShipping={warehouse?.gate_pass_document_shipping_address}
          refetch={refetch}
        />
      ) : null}
    </>
  );
};

export default WarehouseDetail;
